export class GroupMember {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.groupID = json && json.group_id || null;
        this.appUserID = json && json.app_user_id || null;
        this.firstName = json && json.first_name || null;
        this.lastName = json && json.last_name || null;
        this.profileImage = json && json.profile_image || null;
        this.isRinknetStaff = json && json.is_rinknet_staff || null;

        this.selected = false;
    }

    id: number;
    groupID: number;
    appUserID: number;
    firstName: string;
    lastName: string;
    profileImage: string;
    isRinknetStaff: boolean;

    selected: boolean;
}